import { propertyType, t } from '@blocksuite/data-view';
import { DATABASE_ROW_SYSTEM_FIELD_NAMES } from '@streamlain/database-identity';
import zod from 'zod';

export const createdByColumnType = propertyType('created-by');
export const createdByPropertyModelConfig = createdByColumnType.modelConfig({
  name: DATABASE_ROW_SYSTEM_FIELD_NAMES['created-by'],
  propertyData: {
    schema: zod.object({}),
    default: () => ({}),
  },
  jsonValue: {
    schema: zod.string().nullable(),
    type: () => t.user.instance(),
    isEmpty: ({ value }) => !value,
  },
  rawValue: {
    schema: zod.string().nullable(),
    default: () => null,
    toString: ({ value }) => value ?? '',
    fromString: ({ value }) => {
      return { value };
    },
    toJson: ({ value }) => value,
    setValue: () => {},
  },
  fixed: {
    defaultData: {},
    defaultShow: false,
  },
});
